// libraries
import { Spin, Typography } from 'antd';
import styled from 'styled-components';

type IProps = {
	text?: string;
};

export function Spinner(props: IProps): JSX.Element {
	return (
		<Container>
			<Spin size="large" />
			<Typography>{props.text}</Typography>
		</Container>
	);
}

const Container = styled.main`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 1rem;
`;
